module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TaskEdit3-0590ce4a1250a62507db3b60800d65d7.jpg";